import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";
import ProductAggregateRating from "./product-aggregate-rating";

// Heads up, This is a shared component across current PDP and Umiversal PDP
export default function AnchorProductAggregateRating(props) {
  const gridProductDrawer = useSelector(state => state.gridProductDrawer);

  const logClick = () => {
    ActionLogger.logAction({
      objectType: "node",
      action: "click_readreview",
      average_rating: props.reviews.averageRating,
      review_count: props.reviews.count,
      style_name: props.productId,
    });
  };

  const handleClick = event => {
    // anchor links don't seem to work in the GridProductDrawer
    // so this is a workaround to scroll to the reviews section
    if (gridProductDrawer) {
      event.preventDefault();
      document.getElementById("reviews-partial")?.scrollIntoView({ behavior: "smooth" });
    }
    logClick();
  };

  const href = props.redirectUrl ? `${props.redirectUrl}#reviews-partial` : "#reviews-partial";

  return (
    <a
      data-test-id="reviews-link"
      className={`anchor-product-aggregate-rating ${props.className}`}
      href={href}
      onClick={handleClick}>
      <ProductAggregateRating reviews={props.reviews} />
    </a>
  );
}

AnchorProductAggregateRating.propTypes = {
  productId: PropTypes.string,
  reviews: PropTypes.shape({
    averageRating: PropTypes.number,
    count: PropTypes.number,
  }),
  redirectUrl: PropTypes.string,
  className: PropTypes.string,
};

export const { propTypes } = AnchorProductAggregateRating;
